// Note that some endpoints use a terminating slash, this is intentional since we
// use the root endpoint for standard id access, ie. /{id} and it preceds other routes
const API_V1_BASE = "/api/v1";

const apiRoutes = {
  // Account and Users
  accounts: `${API_V1_BASE}/accounts`,
  users: `${API_V1_BASE}/users/?ids=:usersIds`,
  "users/me": `${API_V1_BASE}/users/me/`,
  "users/all": `${API_V1_BASE}/users/all`,
  "users/filter": `${API_V1_BASE}/users/filter`,
  "users/bulk": `${API_V1_BASE}/users/bulk/`,
  "users/roles": `${API_V1_BASE}/users/roles/`,
  "users/provisioning": `${API_V1_BASE}/users/provisioning/`,
  createUser: `${API_V1_BASE}/users/`,
  "users/update": `${API_V1_BASE}/users/:userId`,
  "users/stats": `${API_V1_BASE}/users/stats/`,
  "users/transfer": `${API_V1_BASE}/users/transfer/`,
  "users/areaOfResponsibility": `${API_V1_BASE}/users/area_of_responsibility/`,
  "users/departments": `${API_V1_BASE}/users/departments/`,
  "users/areaOfResponsibility/upsert": `${API_V1_BASE}/users/area_of_responsibility/upsert`,

  // People
  people: `${API_V1_BASE}/people/?ids=:peopleIds`,
  "people/all": `${API_V1_BASE}/people/all`,
  "people/filter": `${API_V1_BASE}/people/filter`,
  "people/company": `${API_V1_BASE}/people/company/:companyId`,
  "people/updateCompany": `${API_V1_BASE}/people/company/:companyId/people`,
  createPerson: `${API_V1_BASE}/people/`,
  createPersonWithDreamer: `${API_V1_BASE}/people/create_with_dreamer`,
  "people/check-duplicates": `${API_V1_BASE}/people/check_duplicates`,
  "people/id": `${API_V1_BASE}/people/:personId`,
  "people/activities/filter": `${API_V1_BASE}/people/:entityId/activities/filter`,
  "people/activities/fetch": `${API_V1_BASE}/people/:entityId/activities/fetch`,
  "people/activities/transcriptProcessing": `${API_V1_BASE}/people/:entityId/activities/transcript_processing`,
  "people/createActivity": `${API_V1_BASE}/people/:entityId/activities`,
  "people/activities/id": `${API_V1_BASE}/people/:entityId/activities/:activityId`,
  "people/jobFunctions": `${API_V1_BASE}/people/job_functions/`,
  "people/updateStatus": `${API_V1_BASE}/people/:personId/status/:status`,
  "people/distinctValues": `${API_V1_BASE}/people/distinct_values/:fieldName`,
  "people/export/create": `${API_V1_BASE}/people/export`,
  "people/export/status": `${API_V1_BASE}/people/export/:jobId`,

  // Companies
  companies: `${API_V1_BASE}/companies/?ids=:companiesIds`,
  "companies/all": `${API_V1_BASE}/companies/all`,
  "companies/filter": `${API_V1_BASE}/companies/filter`,
  "companies/update": `${API_V1_BASE}/companies/:companyId`,
  createCompany: `${API_V1_BASE}/companies/`,
  createCompanyWithDreamer: `${API_V1_BASE}/companies/with_dreamer`,
  "companies/id": `${API_V1_BASE}/companies/:companyId`,
  "companies/activities/filter": `${API_V1_BASE}/companies/:entityId/activities/filter`,
  "companies/activities/fetch": `${API_V1_BASE}/companies/:entityId/activities/fetch`,
  "companies/activities/transcriptProcessing": `${API_V1_BASE}/companies/:entityId/activities/transcript_processing`,
  "companies/industries": `${API_V1_BASE}/companies/industries/`,
  "companies/segments": `${API_V1_BASE}/companies/segments/`,
  "companies/createActivity": `${API_V1_BASE}/companies/:entityId/activities`,
  "companies/activities/id": `${API_V1_BASE}/companies/:entityId/activities/:activityId`,
  "companies/distinctValues": `${API_V1_BASE}/companies/distinct_values/:fieldName`,
  "companies/export/create": `${API_V1_BASE}/companies/export`,
  "companies/export/status": `${API_V1_BASE}/companies/export/:jobId`,
  "companies/check-duplicates": `${API_V1_BASE}/companies/check-duplicates`,
  "companies/commercials": `${API_V1_BASE}/companies/deals_commercials/:companyId`,
  "companies/pastContracts": `${API_V1_BASE}/companies/past_contracts/:companyId`,
  "companyContracts/filter": `${API_V1_BASE}/contracts/:entityId/company_contracts/filter`,

  // Partners
  partners: `${API_V1_BASE}/partners/?ids=:partnersIds`,
  "partners/all": `${API_V1_BASE}/partners/all`,
  "partners/filter": `${API_V1_BASE}/partners/filter`,
  "partners/update": `${API_V1_BASE}/partners/:partnerId`,
  createPartner: `${API_V1_BASE}/partners/`,
  "partners/id": `${API_V1_BASE}/partners/:partnerId`,
  "partners/distinctValues": `${API_V1_BASE}/partners/distinct_values/:fieldName`,
  "partners/export/create": `${API_V1_BASE}/partners/export`,
  "partners/export/status": `${API_V1_BASE}/partners/export/:jobId`,
  "partners/activities/filter": `${API_V1_BASE}/partners/:entityId/activities/filter`,
  "partners/activities/fetch": `${API_V1_BASE}/partners/:entityId/activities/fetch`,
  "partners/activities/transcriptProcessing": `${API_V1_BASE}/partners/:entityId/activities/transcript_processing`,
  "partners/createActivity": `${API_V1_BASE}/partners/:entityId/activities`,
  "partners/activities/id": `${API_V1_BASE}/partners/:entityId/activities/:activityId`,

  // Partner Contacts (mounted under the /partners_contacts prefix in partnersapi)
  partners_contacts: `${API_V1_BASE}/partners/partners_contacts/?ids=:partners_contactsIds`,
  "partners_contacts/all": `${API_V1_BASE}/partners/partners_contacts/all`,
  "partners_contacts/filter": `${API_V1_BASE}/partners/partners_contacts/filter`,
  "partners_contacts/distinctValues": `${API_V1_BASE}/partners/partners_contacts/distinct_values/:fieldName`,
  "partners_contacts/export/create": `${API_V1_BASE}/partners/partners_contacts/export`,
  "partners_contacts/export/status": `${API_V1_BASE}/partners/partners_contacts/export/:jobId`,
  createPartnerContact: `${API_V1_BASE}/partners/partners_contacts/`,
  "partners_contacts/update": `${API_V1_BASE}/partners/partners_contacts/:partnerContactId`,
  "partners_contacts/id": `${API_V1_BASE}/partners/partners_contacts/:partnerContactId`,
  "partners_contacts/activities/filter": `${API_V1_BASE}/partners/partners_contacts/:entityId/activities/filter`,
  "partners_contacts/activities/fetch": `${API_V1_BASE}/partners/partners_contacts/:entityId/activities/fetch`,
  "partners_contacts/activities/transcriptProcessing": `${API_V1_BASE}/partners/partners_contacts/:entityId/activities/transcript_processing`,
  "partners_contacts/createActivity": `${API_V1_BASE}/partners/partners_contacts/:entityId/activities`,
  "partners_contacts/activities/id": `${API_V1_BASE}/partners/partners_contacts/:entityId/activities/:activityId`,

  // Leads
  leads: `${API_V1_BASE}/leads/?ids=:leadsIds`,
  createLeadWithDreamer: `${API_V1_BASE}/leads/with_dreamer`,
  "leads/check-duplicates": `${API_V1_BASE}/leads/check_duplicates`,
  "leads/all": `${API_V1_BASE}/leads/all`,
  "leads/filter": `${API_V1_BASE}/leads/filter`,
  "leads/activities/filter": `${API_V1_BASE}/leads/:entityId/activities/filter`,
  "leads/activities/fetch": `${API_V1_BASE}/leads/:entityId/activities/fetch`,
  "leads/activities/transcriptProcessing": `${API_V1_BASE}/leads/:entityId/activities/transcript_processing`,
  "leads/createActivity": `${API_V1_BASE}/leads/:entityId/activities`,
  "leads/activities/id": `${API_V1_BASE}/leads/:entityId/activities/:activityId`,
  "leads/sources": `${API_V1_BASE}/leads/sources/`,
  "leads/distinctValues": `${API_V1_BASE}/leads/distinct_values/:fieldName`,
  "leads/id": `${API_V1_BASE}/leads/:leadId`,
  createLead: `${API_V1_BASE}/leads/`,
  "leads/disqualifiedReasons": `${API_V1_BASE}/leads/disqualified_reasons/`,
  "leads/closedAsQualifiedReasons": `${API_V1_BASE}/leads/closed_as_qualified_reasons/`,
  "leads/disqualifiedCompanyReasons": `${API_V1_BASE}/leads/disqualified_company_reasons/`,
  "leads/updateStatus": `${API_V1_BASE}/leads/:leadId/status`,
  "leads/unMarkAsStuck": `${API_V1_BASE}/leads/:leadId/unmark_as_stuck`,
  "leads/dealSuggestion": `${API_V1_BASE}/leads/:leadId/deal_suggestion`,
  "leads/dealSuggestionDismiss": `${API_V1_BASE}/leads/:leadId/deal_suggestion/dismiss`,
  "leads/types": `${API_V1_BASE}/leads/leads_types/`,
  "leads/export/create": `${API_V1_BASE}/leads/export`,
  "leads/export/status": `${API_V1_BASE}/leads/export/:jobId`,
  "leads/candidateActionStates": `${API_V1_BASE}/leads/candidates/action_states/`,
  "leads/candidateAccept": `${API_V1_BASE}/leads/candidates/:candidateId/accept`,
  "leads/candidateReject": `${API_V1_BASE}/leads/candidates/:candidateId/reject`,

  // Deals
  deals: `${API_V1_BASE}/deals/?ids=:dealsIds`,
  "deals/me": `${API_V1_BASE}/deals/me/`,
  "deals/all": `${API_V1_BASE}/deals/all`,
  "deals/filter": `${API_V1_BASE}/deals/filter`,
  "deals/updateStage": `${API_V1_BASE}/deals/:dealId/stage/:newStageId`,
  "deals/updateStatus": `${API_V1_BASE}/deals/:dealId/status/`,
  "deals/id": `${API_V1_BASE}/deals/:dealId`,
  dealCreate: `${API_V1_BASE}/deals/`,
  dealMilestones: `${API_V1_BASE}/deals/milestones/`,
  "deals/activities/filter": `${API_V1_BASE}/deals/:entityId/activities/filter`,
  "deals/activities/fetch": `${API_V1_BASE}/deals/:entityId/activities/fetch`,
  "deals/activities/transcriptProcessing": `${API_V1_BASE}/deals/:entityId/activities/transcript_processing`,
  "deals/createActivity": `${API_V1_BASE}/deals/:entityId/activities`,
  "deals/activities/id": `${API_V1_BASE}/deals/:entityId/activities/:activityId`,
  "deals/questionnaireResponses": `${API_V1_BASE}/deals/:dealId/questionnaires/:questionnaireId`,
  "deals/questionnaireRestore": `${API_V1_BASE}/deals/:dealId/questionnaires/:questionnaireId/restore`,
  "deals/questionnaireScores": `${API_V1_BASE}/deals/:dealId/scores/:stageId`,
  "deals/deleteQuestion": `${API_V1_BASE}/deals/:dealId/questionnaires/:questionnaireId/question/:questionId`,
  "deals/nextSteps": `${API_V1_BASE}/deals/:dealId/next_steps/`,
  "deals/updateNextStep": `${API_V1_BASE}/deals/:dealId/next_steps/:nextStepId`,
  "deals/distinctValues": `${API_V1_BASE}/deals/distinct_values/:fieldName`,
  "deals/commercials": `${API_V1_BASE}/deals/:dealId/commercials`,
  "deals/updateAlert": `${API_V1_BASE}/deals/:dealId/alerts/:alertId`,
  "deals/alerts/batch": `${API_V1_BASE}/deals/alerts/batch`,
  "deals/summary": `${API_V1_BASE}/deals/:dealId/summary`,
  "deals/resolveQuestion": `${API_V1_BASE}/deals/:dealId/question/:questionId/resolve`,
  "deals/export/create": `${API_V1_BASE}/deals/export`,
  "deals/export/status": `${API_V1_BASE}/deals/export/:jobId`,
  "deals/closedLostReasonSuggest": `${API_V1_BASE}/deals/:dealId/closed_lost_reason/suggest`,
  "deals/closedLostReasonHistory": `${API_V1_BASE}/deals/:dealId/closed_lost_reason/history`,

  // questionnaire settings
  "questionnaires/byId": `${API_V1_BASE}/settings/questionnaires/by_id/:questionnaireId`,
  "questionnaires/update": `${API_V1_BASE}/settings/questionnaires/:questionnaireId`,
  "questionnaires/restore": `${API_V1_BASE}/settings/questionnaires/:questionnaireId/restore`,
  "questionnaires/create": `${API_V1_BASE}/settings/questionnaires/`,
  "questionnaires/reorder": `${API_V1_BASE}/settings/questionnaires/:stageId/order`,
  "questionnaires/delete": `${API_V1_BASE}/settings/questionnaires/:questionnaireId`,
  "questionnaires/byId/order": `${API_V1_BASE}/settings/questionnaires/by_id/:questionnaireId/order`,

  // Tasks
  tasks: `${API_V1_BASE}/tasks`,
  "tasks/filter": `${API_V1_BASE}/tasks/filter`,
  "tasks/update": `${API_V1_BASE}/tasks/:taskId`,
  "tasks/undoDelete": `${API_V1_BASE}/tasks/:taskId/undo_delete/`,
  "tasks/dreamerUndo": `${API_V1_BASE}/tasks/:taskId/dreamer_undo/`,
  "tasks/dreamerReopen": `${API_V1_BASE}/tasks/:taskId/dreamer_reopen/`,
  "tasks/dreamerComplete": `${API_V1_BASE}/tasks/:taskId/dreamer_complete/`,

  // Views
  views: `${API_V1_BASE}/settings/views/`,
  "views/id": `${API_V1_BASE}/settings/views/:viewId`,
  "views/type": `${API_V1_BASE}/settings/views/type/:typeId`,
  "views/type/config": `${API_V1_BASE}/settings/views/type/:typeId/config`,

  // Settings
  "settings/thresholds/all": `${API_V1_BASE}/settings/thresholds/all`,
  "settings/thresholds/byId": `${API_V1_BASE}/settings/thresholds/:thresholdsId`,
  "settings/thresholds/update": `${API_V1_BASE}/settings/thresholds/:thresholdsId`,
  "settings/account": `${API_V1_BASE}/settings/account/:settingKey`,
  "settings/currencies": `${API_V1_BASE}/settings/currencies/currencies`,
  "settings/currencyRates": `${API_V1_BASE}/settings/currencies/rates?baseCurrency=:currencyCode`,
  "settings/currencyUsage": `${API_V1_BASE}/settings/currencies/usage`,
  "settings/products": `${API_V1_BASE}/settings/products/all`,
  "settings/products/service_items/types": `${API_V1_BASE}/settings/products/service_items/types`,
  "settings/products/pricing_models": `${API_V1_BASE}/settings/products/pricing_models/`,
  "settings/products/service_items": `${API_V1_BASE}/settings/products/:productId/service_items`,
  "settings/products/service_items/byId": `${API_V1_BASE}/settings/products/:productId/service_items/:serviceItemId`,
  "settings/products/service_items/update": `${API_V1_BASE}/settings/products/:productId/service_items/:serviceItemId`,
  "settings/products/service_items/pricing": `${API_V1_BASE}/settings/products/:productId/service_items/:serviceItemId/pricing`,
  "settings/products/service_items/delete": `${API_V1_BASE}/settings/products/:productId/service_items/:serviceItemId`,
  "settings/products/service_items/order": `${API_V1_BASE}/settings/products/:productId/service_items/order`,
  "settings/products/bundles": `${API_V1_BASE}/settings/products/:productId/bundles`,
  "settings/products/bundles/byId": `${API_V1_BASE}/settings/products/:productId/bundles/:bundleId`,
  "settings/products/bundles/update": `${API_V1_BASE}/settings/products/:productId/bundles/:bundleId`,

  "settings/questionnaireSettings": `${API_V1_BASE}/settings/questionnaires/:stageId`,
  "settings/questionnaireAll": `${API_V1_BASE}/settings/questionnaires/all`,
  "settings/createQuestionnaireQuestion": `${API_V1_BASE}/settings/questionnaires/questions`,
  "settings/updateQuestionnaireQuestion": `${API_V1_BASE}/settings/questionnaires/questions/:questionId`,
  "settings/autofillInstructions": `${API_V1_BASE}/settings/questionnaires/questions/:questionId/autofill/instructions`,
  "settings/autofillTestRuns": `${API_V1_BASE}/settings/questionnaires/questions/:questionId/autofill/test_runs`,
  "settings/autofillTestRunById": `${API_V1_BASE}/settings/questionnaires/questions/:questionId/autofill/test_runs/:testRunId`,
  "settings/questionOptions": `${API_V1_BASE}/settings/questionnaires/questions/:questionId/options/all`,
  "settings/createQuestionOption": `${API_V1_BASE}/settings/questionnaires/questions/:questionId/options/`,
  "settings/activities/tags": `${API_V1_BASE}/settings/activities/tags/:activityType`,
  "settings/tokens/all": `${API_V1_BASE}/settings/tokens/`,

  // Settings - products
  productCreate: `${API_V1_BASE}/settings/products/`,
  productLicensesBulkCreate: `${API_V1_BASE}/settings/products_licenses/bulk/`,
  productLicensesBulkUpsert: `${API_V1_BASE}/settings/products_licenses/bulk/upsert`,
  "products/update": `${API_V1_BASE}/settings/products/:productId`,
  "products/delete": `${API_V1_BASE}/settings/products/:productId`,
  "products_licenses/delete": `${API_V1_BASE}/settings/products_licenses/:licenseId`,
  "settings/industries": `${API_V1_BASE}/settings/companies/industries/`,
  "settings/industries/usage": `${API_V1_BASE}/settings/companies/industries/:industryId/usage`,
  "settings/subIndustries": `${API_V1_BASE}/settings/companies/sub_industries`,
  "settings/subIndustriesByIndustry": `${API_V1_BASE}/settings/companies/industries/:industryId/sub_industries`,
  "settings/subIndustries/bulkUpdate": `${API_V1_BASE}/settings/companies/industries/:industryId/sub_industries/bulk/update`,
  "settings/subIndustries/usage": `${API_V1_BASE}/settings/companies/industries/:industryId/sub_industries/:subIndustryId/usage`,
  "settings/tokens": `${API_V1_BASE}/settings/tokens/:serviceId`,

  // Settings - deals
  "settings/deals/closedLostReasons": `${API_V1_BASE}/settings/deals/closed_lost_reasons/`,
  "settings/deals/closedLostReasons/create": `${API_V1_BASE}/settings/deals/closed_lost_reasons/`,
  "settings/deals/closedLostReasons/update": `${API_V1_BASE}/settings/deals/closed_lost_reasons/:closedLostReasonId`,
  "settings/deals/closedLostReasons/delete": `${API_V1_BASE}/settings/deals/closed_lost_reasons/:closedLostReasonId`,
  "settings/deals/closedLostReasons/order": `${API_V1_BASE}/settings/deals/closed_lost_reasons/order/`,
  "settings/deals/stages": `${API_V1_BASE}/settings/deals/stages/`,
  "settings/deals/stages/order": `${API_V1_BASE}/settings/deals/stages/order/`,
  "settings/deals/stages/stageById": `${API_V1_BASE}/settings/deals/stages/:stageId`,

  //Settings - leads
  "settings/leads/inboundCampaignTypes": `${API_V1_BASE}/settings/leads/inbound_campaign_types/`,
  "settings/leads/outboundCampaignTypes": `${API_V1_BASE}/settings/leads/outbound_campaign_types/`,
  "settings/leads/disqualifiedReasons": `${API_V1_BASE}/settings/leads/disqualified_reasons/`,
  "settings/leads/disqualifiedReasons/create": `${API_V1_BASE}/settings/leads/disqualified_reasons/`,
  "settings/leads/disqualifiedReasons/update": `${API_V1_BASE}/settings/leads/disqualified_reasons/:reasonId`,
  "settings/leads/disqualifiedReasons/delete": `${API_V1_BASE}/settings/leads/disqualified_reasons/:reasonId`,
  "settings/leads/disqualifiedReasons/order": `${API_V1_BASE}/settings/leads/disqualified_reasons/order/`,
  "settings/leads/closedAsQualifiedReasons": `${API_V1_BASE}/settings/leads/closed_as_qualified_reasons/`,
  "settings/leads/closedAsQualifiedReasons/create": `${API_V1_BASE}/settings/leads/closed_as_qualified_reasons/`,
  "settings/leads/closedAsQualifiedReasons/update": `${API_V1_BASE}/settings/leads/closed_as_qualified_reasons/:reasonId`,
  "settings/leads/closedAsQualifiedReasons/delete": `${API_V1_BASE}/settings/leads/closed_as_qualified_reasons/:reasonId`,
  "settings/leads/closedAsQualifiedReasons/order": `${API_V1_BASE}/settings/leads/closed_as_qualified_reasons/order/`,

  // Settings - entities
  "settings/entityType/fields": `${API_V1_BASE}/settings/:entityType/fields/`,
  "settings/entityType/fields/additionals": `${API_V1_BASE}/settings/:entityType/fields/`,
  "settings/entityType/fields/order": `${API_V1_BASE}/settings/:entityType/fields/order`,
  "settings/entityType/fields/create": `${API_V1_BASE}/settings/:entityType/fields/`,
  "settings/entityType/fields/update": `${API_V1_BASE}/settings/:entityType/fields/:fieldId`,
  "settings/entityType/fields/delete": `${API_V1_BASE}/settings/:entityType/fields/:fieldId`,
  "settings/entityType/fields/displayTypeTargets": `${API_V1_BASE}/settings/:entityType/fields/:fieldId/display_type_targets`,
  "settings/entityType/fields/bulkUpdate": `${API_V1_BASE}/settings/:entityType/:fieldKey/bulk/update/`,
  "settings/entityType/fields_sections": `${API_V1_BASE}/settings/:entityType/fields_sections/`,

  // History
  "history/filter": `${API_V1_BASE}/history/filter`,

  // Attachments
  attachments: `${API_V1_BASE}/attachments/`,
  "attachments/id": `${API_V1_BASE}/attachments/:attachmentId`,
  "attachments/filter": `${API_V1_BASE}/attachments/:attachmentId/filter`,

  // Reports
  "reports/type": `${API_V1_BASE}/reports/:type`,
  "reports/type/directReports": `${API_V1_BASE}/reports/:type/direct_reports`,

  // Analytics
  "analytics/fetchWithBreakdowns": `${API_V1_BASE}/reports/analytics/fetch_with_breakdowns`,

  // Import
  "import/leads": `${API_V1_BASE}/accessenabler/import/leads`,
  "import/leadsStatus": `${API_V1_BASE}/accessenabler/import/leads/:import_id`,

  // Reports Scheduler
  "reports/scheduler": `${API_V1_BASE}/reports/scheduler/`,
  "reports/scheduler/id": `${API_V1_BASE}/reports/scheduler/:id`,
  "reports/scheduler/filter": `${API_V1_BASE}/reports/scheduler/filter`,

  // Saved Reports
  "reports/saved/filter": `${API_V1_BASE}/reports/saved/filter`,
  "reports/saved/run": `${API_V1_BASE}/reports/saved/:reportId/run`,
  "reports/saved/run/item": `${API_V1_BASE}/reports/saved/:reportId/runs/:runId`,
  "reports/saved/unseen-count": `${API_V1_BASE}/reports/saved/unseen-count`,
  "reports/saved/seen": `${API_V1_BASE}/reports/saved/seen`,

  // Other
  "messaging/ws": `${API_V1_BASE}/messaging/ws`,
  "messaging/id": `${API_V1_BASE}/messaging/:messageId`,
  "messaging/suggestions": `${API_V1_BASE}/messaging/suggestions`,
  "messaging/draftRegenerate": `${API_V1_BASE}/messaging/drafts/:messageId/regenerate`,
  "messaging/draftSelectedVersion": `${API_V1_BASE}/messaging/drafts/:messageId/selected_version`,
  registerGoogleEmail: "/integrations/emailcal/google/register",
  registerMicrosoftEmail: "/integrations/emailcal/microsoft/register",
  registerZoom: "/integrations/zoom/register",
  disconnectZoom: "/integrations/zoom/disconnect",
  registerZoomInfo: "/integrations/zoominfo/register",
  disconnectZoomInfo: "/integrations/zoominfo/connection",
  inviteNotetaker: "/integrations/zoom/meetingbot/invite",
  registerSlack: "/integrations/slack/register",
  disconnectSlack: "/integrations/slack/disconnect",
  connectPandaDoc: `${API_V1_BASE}/esignconnector/esign/pandadoc/connection`,
  "esign/requests/refresh": `${API_V1_BASE}/esignconnector/esign/requests/refresh`,
  "esignconnector/connection": `${API_V1_BASE}/esignconnector/esign/connection`,
  registerGoogleDrive: `${API_V1_BASE}/driveconnector/google/oauth/authorize?provider=google_app_script`,
  "driveconnector/status": `${API_V1_BASE}/driveconnector/status`,

  // Global Search
  "search/global": `${API_V1_BASE}/search/global`,
  "search/global/recent": `${API_V1_BASE}/search/recent`,
  "search/global/recent/create": `${API_V1_BASE}/search/recent`,
  "search/global/recent/delete": `${API_V1_BASE}/search/global/recent/delete:searchId`,
  "search/global/recent/delete/all": `${API_V1_BASE}/search/global/recent/delete`,

  // Personal Access Tokens
  "pat/me": `${API_V1_BASE}/accessenabler/tokens/me`,
  "pat/create": `${API_V1_BASE}/accessenabler/tokens/`,
  "pat/delete": `${API_V1_BASE}/accessenabler/tokens/:tokenId`,

  // Event Hooks
  "event_hooks/execute": `${API_V1_BASE}/accessenabler/event_hooks/:hookId/execute`,

  // Apollo
  "apollo/settings": `${API_V1_BASE}/accessenabler/connectors/apollo/settings`,
  "apollo/settings/listSync": `${API_V1_BASE}/accessenabler/connectors/apollo/settings/list_sync`,
  "apollo/settings/dialer": `${API_V1_BASE}/accessenabler/connectors/apollo/settings/dialer`,
  "apollo/settings/contactImport": `${API_V1_BASE}/accessenabler/connectors/apollo/settings/contact_import`,
  "apollo/lists": `${API_V1_BASE}/accessenabler/connectors/apollo/lists`,
  "apollo/callOutcomes": `${API_V1_BASE}/accessenabler/connectors/apollo/call_outcomes`,
  "hubspot/settings": `${API_V1_BASE}/accessenabler/connectors/hubspot/settings`,
  "hubspot/forms": `${API_V1_BASE}/accessenabler/connectors/hubspot/forms`,
  "webForm/settings": `${API_V1_BASE}/accessenabler/connectors/web_form/settings`,
  "webForm/settings/status": `${API_V1_BASE}/accessenabler/connectors/web_form/settings/status`,
  "webForm/settings/form": `${API_V1_BASE}/accessenabler/connectors/web_form/settings/form`,
  "webForm/settings/rotateKey": `${API_V1_BASE}/accessenabler/connectors/web_form/settings/rotate_key`,
  "webForm/settings/routing": `${API_V1_BASE}/accessenabler/connectors/web_form/settings/routing`,
  "webForm/settings/fieldMap": `${API_V1_BASE}/accessenabler/connectors/web_form/settings/field_map`,
  "webForm/settings/leadFields": `${API_V1_BASE}/accessenabler/connectors/web_form/settings/lead_fields`,
  "webForm/scriptTag": `${API_V1_BASE}/accessenabler/connectors/web_form/script_tag`,
  "forms/productMap": `${API_V1_BASE}/accessenabler/connectors/forms/product_map`,
  "contractSubmissions/settings": `${API_V1_BASE}/accessenabler/contract_submissions/settings`,
  "contractSubmissions/settings/general": `${API_V1_BASE}/accessenabler/contract_submissions/settings/general`,
  "contractSubmissions/settings/fulfillment": `${API_V1_BASE}/accessenabler/contract_submissions/settings/fulfillment`,
  "contractSubmissions/settings/stripe": `${API_V1_BASE}/accessenabler/contract_submissions/settings/sources/stripe`,
  "contractSubmissions/settings/stripe/mapping": `${API_V1_BASE}/accessenabler/contract_submissions/settings/sources/stripe/mapping`,

  // Stripe Checkout (payconnector)
  "stripe/settings": `${API_V1_BASE}/payconnector/payments/stripe/settings`,
  "stripe/settings/connection": `${API_V1_BASE}/payconnector/payments/stripe/settings/connection`,
  "stripe/settings/secrets": `${API_V1_BASE}/payconnector/payments/stripe/settings/secrets`,
  "stripe/settings/test": `${API_V1_BASE}/payconnector/payments/stripe/settings/test`,

  // Contracts
  "contracts/create": `${API_V1_BASE}/contracts/`,
  "contracts/activities/filter": `${API_V1_BASE}/contracts/:entityId/activities/filter`,
  "contracts/activities/fetch": `${API_V1_BASE}/contracts/:entityId/activities/fetch`,
  "contracts/activities/transcriptProcessing": `${API_V1_BASE}/contracts/:entityId/activities/transcript_processing`,
  "contracts/createActivity": `${API_V1_BASE}/contracts/:entityId/activities`,
  "contracts/activities/id": `${API_V1_BASE}/contracts/:entityId/activities/:activityId`,
  "contracts/id": `${API_V1_BASE}/contracts/:contractId`,
  "contracts/duplicate": `${API_V1_BASE}/contracts/:contractId/duplicate`,
  "contracts/terms/fieldSettings": `${API_V1_BASE}/contracts/:contractId/terms/field_settings`,
  "contracts/terms/preview": `${API_V1_BASE}/contracts/:contractId/terms/preview`,
  "contracts/terms/amendments": `${API_V1_BASE}/contracts/:contractId/terms/amendments`,
  "contracts/terms/corrections": `${API_V1_BASE}/contracts/:contractId/terms/corrections`,
  "contracts/terms/versions": `${API_V1_BASE}/contracts/:contractId/terms/versions`,
  "contracts/terms/versionChanges": `${API_V1_BASE}/contracts/:contractId/terms/versions/:versionId/changes`,
  "contracts/terms/versionDetail": `${API_V1_BASE}/contracts/:contractId/terms/versions/:versionId`,
  "contracts/terms/versionWithdraw": `${API_V1_BASE}/contracts/:contractId/terms/versions/:versionId/withdraw`,
  "contracts/dealArr": `${API_V1_BASE}/contracts/deal_arr/:dealId`,
  "contracts/dealCurrency": `${API_V1_BASE}/contracts/deal_currency/:dealId`,
  "contracts/revenueItems/create": `${API_V1_BASE}/contracts/revenue_items/:contractId/revenue_items`,
  "contracts/revenueItems/update": `${API_V1_BASE}/contracts/revenue_items/:contractId/revenue_items/:revenueItemId`,
  "contracts/revenueItems/delete": `${API_V1_BASE}/contracts/revenue_items/:contractId/revenue_items/:revenueItemId`,
  "contracts/revenueItems/deleteAll": `${API_V1_BASE}/contracts/revenue_items/:contractId/revenue_items`,
  "contracts/revenueItems/order": `${API_V1_BASE}/contracts/revenue_items/:contractId/revenue_items/order`,
  "contracts/bundles/addToDeal": `${API_V1_BASE}/contracts/bundles/deals/:dealId`,
  "contracts/bundles/addToContract": `${API_V1_BASE}/contracts/bundles/contracts/:contractId`,
  "contracts/bundles/list": `${API_V1_BASE}/contracts/bundles/contracts/:contractId`,
  "contracts/bundles/update": `${API_V1_BASE}/contracts/bundles/:bundleId`,
  "contracts/bundles/delete": `${API_V1_BASE}/contracts/bundles/:bundleId`,
  "contracts/workflowResponses": `${API_V1_BASE}/contracts/:contractId/workflows/:workflowId`,
  "contracts/workflowResponse/item": `${API_V1_BASE}/contracts/:contractId/workflows/:workflowId/items/:itemId`,
  "contracts/onboardingStage": `${API_V1_BASE}/contracts/:contractId/onboarding_stage/:stageId`,
  "contracts/workflowItemResolve": `${API_V1_BASE}/contracts/:contractId/workflow_items/:itemId/resolve`,
  "contracts/serviceItems/filter": `${API_V1_BASE}/contracts/revenue_items/filter`,
  "contracts/filter": `${API_V1_BASE}/contracts/filter`,
  "contracts/proposals/templates/active": `${API_V1_BASE}/contracts/proposals/templates/active`,
  // A template file path has at most one directory ("fonts/x.ttf"); its slash must stay unescaped.
  "contracts/proposals/templates/file": `${API_V1_BASE}/contracts/proposals/templates/versions/:versionId/files/:file`,
  "contracts/proposals/templates/fileInDirectory": `${API_V1_BASE}/contracts/proposals/templates/versions/:versionId/files/:directory/:file`,
  "contracts/proposals/generate": `${API_V1_BASE}/contracts/proposals/generate`,
  "contracts/proposals/compose": `${API_V1_BASE}/contracts/proposals/compose`,
  "contracts/proposals": `${API_V1_BASE}/contracts/proposals`,
  "contracts/proposals/proposalById": `${API_V1_BASE}/contracts/proposals/:proposalId`,
  "contracts/proposals/send": `${API_V1_BASE}/contracts/proposals/:proposalId/send`,
  "contracts/proposals/revise": `${API_V1_BASE}/contracts/proposals/:proposalId/revise`,
  "contracts/proposals/withdraw": `${API_V1_BASE}/contracts/proposals/:proposalId/withdraw`,
  "contracts/proposals/versions": `${API_V1_BASE}/contracts/proposals/:proposalId/versions`,
  "contracts/compare": `${API_V1_BASE}/contracts/compare`,
  "contracts/companies/compare": `${API_V1_BASE}/contracts/companies/compare`,
  "contracts/services/compare": `${API_V1_BASE}/contracts/services/compare`,
  "contracts/export/create": `${API_V1_BASE}/contracts/export`,
  "contracts/export/status": `${API_V1_BASE}/contracts/export/:jobId`,
  "contracts/revenueItems/export/create": `${API_V1_BASE}/contracts/revenue_items/export`,
  "contracts/revenueItems/export/status": `${API_V1_BASE}/contracts/revenue_items/export/:jobId`,
  "settings/contracts/fields": `${API_V1_BASE}/settings/contracts/fields/`,
  "settings/revenueItems/fields": `${API_V1_BASE}/settings/revenue_items/fields/`,
  "settings/contracts/stages": `${API_V1_BASE}/settings/contracts/stages/`,
  "settings/contracts/stages/order": `${API_V1_BASE}/settings/contracts/stages/order`,
  "settings/contracts/stages/stageById": `${API_V1_BASE}/settings/contracts/stages/:stageId`,
  "settings/contracts/stages/workflows": `${API_V1_BASE}/settings/contracts/stages/workflows/`,
  "settings/contracts/stages/workflows/all": `${API_V1_BASE}/settings/contracts/stages/workflows/all`,
  "settings/contracts/stages/workflows/order": `${API_V1_BASE}/settings/contracts/stages/workflows/order`,
  "settings/contracts/stages/workflows/workflowById": `${API_V1_BASE}/settings/contracts/stages/workflows/:workflowId`,
  "settings/contracts/stages/workflows/items": `${API_V1_BASE}/settings/contracts/stages/workflows/items/`,
  "settings/contracts/stages/workflows/items/order": `${API_V1_BASE}/settings/contracts/stages/workflows/items/order`,
  "settings/contracts/stages/workflows/items/itemById": `${API_V1_BASE}/settings/contracts/stages/workflows/items/:itemId`,
  "settings/contracts/stages/workflows/items/autofillInstructions": `${API_V1_BASE}/settings/contracts/stages/workflows/items/:itemId/autofill/instructions`,
  "settings/contracts/stages/workflows/items/autofillTestRuns": `${API_V1_BASE}/settings/contracts/stages/workflows/items/:itemId/autofill/test_runs`,
  "settings/contracts/stages/workflows/items/autofillTestRunById": `${API_V1_BASE}/settings/contracts/stages/workflows/items/:itemId/autofill/test_runs/:testRunId`,
  "settings/contracts/workflowScoreStatuses": `${API_V1_BASE}/settings/contracts/workflow_score_statuses/`
} as const;

export default apiRoutes;
